import { connect } from 'react-redux'
import { withProps, compose } from 'recompose'
import withType from 'components/common/hoc/withType'
import withViewHide from 'components/common/hoc/withViewHide'
import { omitExcessiveItems, createBlockTitle } from 'helpers/global-search'

export default ({
  TileComponent,
  blockName,
  mapDispatchToProps,
  mapStateToProps,
  processData,
  type
}) => compose(
  withType({ type }),
  withViewHide(({ records = []}) => records.length === 0),
  connect(mapStateToProps, mapDispatchToProps),
  withProps(({
    displayGlobalSearch,
    records,
    recsPerPage,
    totalNumRecs,
    viewAllLink
  }) => ({
    TileComponent,
    title: createBlockTitle(blockName, totalNumRecs),
    viewAllLink: displayGlobalSearch ? viewAllLink : null,
    tiles: processData(
      displayGlobalSearch ?
        omitExcessiveItems(records, recsPerPage) :
        records
    )
  }))
)
